module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"page-title":"Member Services & Resources","desc":"Discover a full suite of services and resources available to DFM members. "},"ar":{"page-title":"خدمات الأعضاء والموارد ","desc":"اكتشف مجموعة خدماتنا الكاملة والموارد المتاحة لأعضاء سوق دبي المالي."}}')
  delete Component.options._Ctor
}
